import { Col } from "antd";
import { useMemo } from "react";
import { useItemVariants } from "graphql/useItemExtras";
import { useTranslation } from "react-i18next";
import Items from "./Items/Items";
import s from "./styles";

function InventoryAdvanced({ values, variantId, stock, items }) {
  const { t } = useTranslation();

  const { itemVariants } = useItemVariants();
  const itemVariantsMap = useMemo(() => {
    const result = {};
    itemVariants.forEach(
      (itemVariant) => (result[itemVariant._id] = itemVariant)
    );
    return result;
  }, [itemVariants]);

  const prices = useMemo(() => {
    if (!values || !values.variantConfig) {
      return {};
    }

    return stock.reduce((acc, item) => {
      const variant = values.variantConfig.variants.find(
        (variant) => variant.variant === item.barcode
      );

      const price = variant ? variant.price : null;

      acc[item.barcode] = price !== null ? price.toString() : null;
      return acc;
    }, {});
  }, [stock, values]);

  return (
    <s.OptionsBoxContainer style={{ marginTop: "48px" }}>
      <s.OptionRowStock>
        <s.SlockSectionTitleHeader>
          {t(
            "components.InventoryItems.AddItem.InventoryAdvanced.advancedInventory"
          )}
        </s.SlockSectionTitleHeader>
      </s.OptionRowStock>

      <s.OptionRow color="#F9F9F9">
        <Col span={6}>
          <s.OptionTextContainer>
            {t("components.InventoryItems.AddItem.InventoryAdvanced.barCode")}
          </s.OptionTextContainer>
        </Col>
        <Col span={6}>
          <s.OptionTextContainer>
            {t(
              "components.InventoryItems.AddItem.InventoryAdvanced.attributes"
            )}
            1
          </s.OptionTextContainer>
        </Col>
        <Col span={6}>
          <s.OptionTextContainer>
            {t("components.InventoryItems.AddItem.InventoryAdvanced.price")}
          </s.OptionTextContainer>
        </Col>
        <Col span={6}>
          <s.OptionTextContainer>
            {t("components.InventoryItems.AddItem.InventoryAdvanced.stock")}
          </s.OptionTextContainer>
        </Col>
      </s.OptionRow>
      {stock.map((item, index) => (
        <Items
          key={index}
          index={index}
          item={item}
          items={items}
          values={values}
          prices={prices}
          itemVariant={variantId && itemVariantsMap[variantId.toString()]}
        />
      ))}
    </s.OptionsBoxContainer>
  );
}

export default InventoryAdvanced;
